require("@babel/polyfill");
// require("./utils/events.ts");

import {Application} from "./application/application";
import {ComponentService} from "./service/component";
import EventsHandler from "./service/events";
import {CarouselComponent} from "./component/carousel";
import {ProductSlidesComponent} from "./component/product-slides";
import {AnimationService} from "./service/animation";
import {ViewportService} from "./service/viewport";

(($) => $(() => {

    let components = new ComponentService();
    (<any>window).events = undefined === (<any>window).events ? new EventsHandler() : (<any>window).events;
    components.addComponent('.js-carousel', CarouselComponent, 'CarouselComponent');
    new Application(components, (<any>window).events, null, new AnimationService());
    new ViewportService((<any>window).events).start();

}))(jQuery);